import React from "react";
import PropTypes from "prop-types";

const BUCKETS = [
    { label: "Up to 6h",   colorBar: "bg-[#28A48B]", colorText: "text-[#28A48B]", key: "upTo6h" },
    { label: "6h – 24h",   colorBar: "bg-yellow-400", colorText: "text-yellow-600", key: "from6hTo24h" },
    { label: "> 24h",      colorBar: "bg-red-400",    colorText: "text-red-500",   key: "over24h" },
];

function TATDistribution({ distribution }) {
    if (!distribution) return null;

    const counts = BUCKETS.map(b => ({
        ...b,
        count: distribution[b.key] ?? 0,
    }));
    if (!counts.some(c => c.count > 0)) return null;
    const maxCount = Math.max(...counts.map(c => c.count), 1);

    return (
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-5">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-4">TAT Distribution</p>
            <div className="flex gap-4 items-end h-16">
                {counts.map(b => (
                    <div key={b.label} className="flex flex-col items-center gap-1 flex-1">
                        <span className={`text-sm font-bold ${b.count > 0 ? b.colorText : "text-gray-300"}`}>
                            {b.count}
                        </span>
                        <div className="w-full flex items-end" style={{ height: 32 }}>
                            <div
                                className={`w-full rounded-t ${b.count > 0 ? b.colorBar : "bg-gray-100"}`}
                                style={{ height: b.count > 0 ? `${(b.count / maxCount) * 100}%` : 4 }}
                            />
                        </div>
                        <span className="text-[10px] text-gray-400 text-center leading-tight">{b.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

TATDistribution.propTypes = {
    distribution: PropTypes.shape({
        upTo6h: PropTypes.number,
        from6hTo24h: PropTypes.number,
        over24h: PropTypes.number,
    }),
};

export default TATDistribution;
